import React, { useState } from "react";
import "./style.css";
import { Row, Col } from "antd";
import { connect } from "react-redux";
import { Register, Login as Logined, Success } from "../../components";
import { login, userInfo } from "../../actions/user";

const mapDispatchToProps = (dispatch: any) => ({
  login: (value: any) => dispatch(login(value)),
  userInfo: (value: any) => dispatch(userInfo(value)),
});

const mapStateToProps = (user: any) => ({ user });

const Login = (props: any) => {
  const { history, login, user } = props;
  const [status, changeStatus] = useState("login");

  const login_page = () => {
    console.log(status);
    switch (status) {
      case "login":
        return (
          <Logined
            changeStatus={() => changeStatus("register")}
            history={history}
            login={login}
          />
        );
      case "register":
        return (
          <Register
            userInfo={props.userInfo}
            changeStatus={(data: string) => changeStatus(data)}
          />
        );
      case "success":
        return <Success changeStatus={() => changeStatus("login")} />;

      default:
        return (
          <Logined
            changeStatus={() => changeStatus("register")}
            history={history}
            login={login}
          />
        );
    }
  };

  return (
    <div className="login">
      <div className="login_wrapper">
        <div className="login_form">{login_page()}</div>
      </div>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
